import elementResizeDetectorMaker from 'element-resize-detector';
import type { ITimelineView } from './TimelineView';
import type { ScenarioTimelineGroup, ScenarioTimelineItem } from './types';

function addListener(
  component: ITimelineView<ScenarioTimelineItem, ScenarioTimelineGroup>,
) {
  if (!component._erd) {
    component._erd = elementResizeDetectorMaker({
      strategy: 'scroll',
    });
  }

  const container = component.container;
  if (!container) {
    // Try to schedule retry on next tick if container not available
    setTimeout(() => {
      if (component.container) {
        addListener(component);
      }
    }, 0);
    return;
  }

  // Store initial width
  component._erdWidth = container.offsetWidth;

  // Cleanup any existing listeners before adding new ones
  try {
    component._erd.removeAllListeners(container);
  } catch (err) {
    console.error('Error removing timeline resize listener', err);
  }

  // Add new listener
  component._erd.listenTo(container, (element: HTMLElement) => {
    if (!component || !component.resize) return;

    const width = element.offsetWidth;
    if (component._erdWidth !== width) {
      // Schedule resize on next tick to avoid react batch update issues
      setTimeout(() => {
        if (component && component.resize) {
          component.resize(component.props);
          component._erdWidth = width;
        }
      }, 0);
    }
  });
}

function removeListener(
  component: ITimelineView<ScenarioTimelineItem, ScenarioTimelineGroup>,
) {
  if (!component._erd) return;

  const container = component.container;
  if (!container) return;

  try {
    component._erd.uninstall(container);
    component._erd = undefined;
    component._erdWidth = undefined;
  } catch (err) {
    console.error('Error removing resize listener from timeline', err);
  }
}

export default { addListener, removeListener };
